import React, { useState } from "react";
import { BrandComponent } from "./components/brand.component";
import { NavbarComponent } from "./components/navbar.component";

interface IHeaderComponentProps {}

export const HeaderComponent: React.FC<IHeaderComponentProps> = (
    props: IHeaderComponentProps
) => {
    return (
        <header
            id="header"
            className="header d-flex align-items-center fixed-top"
            style={{ background: "whitesmoke" }}
        >
            <div className="container position-relative d-flex align-items-center justify-content-between">
                <BrandComponent />

                <NavbarComponent />

                <a className="cta-btn gradient-bg" href="#about">
                    Get Started
                </a>
            </div>
        </header>
    );
};
